/* Alpha & Omega v4 · kleine interacties. Geen afhankelijkheden, werkt zonder netwerk. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Scroll-reveal */
  const reveal = (root = document) => {
    const els = root.querySelectorAll('[data-ao4-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach((el) => io.observe(el));
  };

  /* Tabs (momenten) met pijltjestoetsen */
  class Ao4Tabs extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.select(i));
        tab.addEventListener('keydown', (e) => {
          const k = e.key; let n = null;
          if (k === 'ArrowRight') n = (i + 1) % this.tabs.length;
          if (k === 'ArrowLeft') n = (i - 1 + this.tabs.length) % this.tabs.length;
          if (k === 'Home') n = 0;
          if (k === 'End') n = this.tabs.length - 1;
          if (n !== null) { e.preventDefault(); this.select(n, true); }
        });
      });
    }
    select(i, focus) {
      this.tabs.forEach((t, j) => {
        const on = i === j;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) this.tabs[i].focus();
    }
  }

  /* Etiketregels uitklappen ("waarom zit dit erin?") */
  class Ao4Label extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('[data-row]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const open = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', !open);
          const why = document.getElementById(btn.getAttribute('aria-controls'));
          if (why) why.hidden = open;
        });
      });
    }
  }

  /* Prijs per training */
  class Ao4Calc extends HTMLElement {
    connectedCallback() {
      this.unit = Number(this.dataset.unit) || 0;          // centen per pot
      this.servings = Number(this.dataset.servings) || 1;
      this.t2 = Number(this.dataset.tier2) || 0;
      this.t3 = Number(this.dataset.tier3) || 0;
      this.locale = this.dataset.locale || 'nl-NL';
      this.currency = this.dataset.currency || 'EUR';
      this.range = this.querySelector('[data-sessions]');
      this.on = () => this.update();
      this.range.addEventListener('input', this.on);
      this.querySelectorAll('[data-pots]').forEach((r) => r.addEventListener('change', this.on));
      this.update();
    }
    money(c) {
      if (this.currency === 'EUR') return '€' + (c / 100).toFixed(2).replace('.', ',');
      try { return new Intl.NumberFormat(this.locale, { style: 'currency', currency: this.currency }).format(c / 100); } catch (e) { return (c / 100).toFixed(2); }
    }
    update() {
      const s = Number(this.range.value);
      const min = Number(this.range.min); const max = Number(this.range.max);
      this.range.style.setProperty('--p', `${((s - min) / (max - min)) * 100}%`);
      const pots = Number((this.querySelector('[data-pots]:checked') || {}).value || 1);
      const pct = pots === 2 ? this.t2 : pots === 3 ? this.t3 : 0;
      const full = this.unit * pots;
      const total = full - Math.floor((full * pct) / 100);
      const perServing = total / (this.servings * pots);
      const weeks = (this.servings * pots) / s;
      this.querySelector('[data-out-sessions]').textContent = s;
      this.querySelector('[data-out-serving]').textContent = this.money(Math.round(perServing));
      this.querySelector('[data-out-weeks]').textContent = weeks >= 10 ? Math.round(weeks) : weeks.toFixed(1).replace('.', ',');
      this.querySelector('[data-out-total]').textContent = this.money(Math.round(total));
      const link = this.querySelector('[data-calc-cta]');
      if (link) {
        const radio = document.querySelector(`.buy-form input[name="quantity"][value="${pots}"]`);
        link.dataset.qty = pots;
        link.onclick = radio ? () => { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); } : null;
      }
    }
  }

  /* Batchcheck: toont het voorbeeldrapport, doet geen netwerkverzoek */
  class Ao4Batch extends HTMLElement {
    connectedCallback() {
      const form = this.querySelector('form');
      const out = this.querySelector('[data-found]');
      const doc = document.getElementById(this.dataset.doc);
      form.addEventListener('submit', (e) => {
        e.preventDefault();
        const v = (form.querySelector('input').value || '').trim().toUpperCase();
        if (!out) return;
        out.hidden = false;
        out.textContent = v
          ? (this.dataset.found || '').replace('[code]', v)
          : (this.dataset.empty || '');
        if (doc && v) { const code = doc.querySelector('[data-doc-batch]'); if (code) code.textContent = v; }
        if (doc && v && !reduce && doc.animate) doc.animate([{ transform: 'rotate(-1.2deg) scale(.98)' }, { transform: 'rotate(0) scale(1)' }], { duration: 450, easing: 'cubic-bezier(.22,1,.36,1)' });
      });
    }
  }

  /* Reviewfilter */
  class Ao4Reviews extends HTMLElement {
    connectedCallback() {
      const chips = [...this.querySelectorAll('[data-filter]')];
      const cards = [...this.querySelectorAll('[data-tags]')];
      const live = this.querySelector('[data-live]');
      const list = this.querySelector('[data-rev-list]');
      const more = this.querySelector('[data-rev-more]');
      const open = () => { if (list) list.classList.add('is-open'); if (more) { more.hidden = true; more.setAttribute('aria-expanded', 'true'); } };
      if (more) more.addEventListener('click', () => { open(); const next = list && list.querySelector('.ao4-card:nth-child(4)'); if (next) next.setAttribute('tabindex', '-1'), next.focus({ preventScroll: true }); });
      chips.forEach((chip) => chip.addEventListener('click', () => {
        const f = chip.dataset.filter;
        if (f !== 'all') open();
        chips.forEach((c) => c.setAttribute('aria-pressed', c === chip));
        let n = 0;
        cards.forEach((card) => { const show = f === 'all' || card.dataset.tags.split(' ').includes(f); card.hidden = !show; if (show) { n += 1; card.classList.add('is-in'); } });
        if (live) live.textContent = `${n} ${live.dataset.label || ''}`;
      }));
    }
  }

  const define = (n, c) => { if (!customElements.get(n)) customElements.define(n, c); };
  define('ao4-tabs', Ao4Tabs);
  define('ao4-label', Ao4Label);
  define('ao4-calc', Ao4Calc);
  define('ao4-batch', Ao4Batch);
  define('ao4-reviews', Ao4Reviews);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => reveal()); else reveal();
  document.addEventListener('shopify:section:load', (e) => reveal(e.target));
})();
